import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserService } from '@carm/_core/access-control-mgt/facade/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { IErrorDataResponse, IErrorLogResponse, is502Error } from './models/error.model';
import { getMessageByCode } from '../helper-functions/error-mapper-functions';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';

@Injectable()
export class LoggerService {
  constructor(
    protected http: HttpClient,
    protected router: Router,
    protected userService: UserService,
    protected translateService: TranslateService,
    protected activatedRoute: ActivatedRoute
  ) {}

  public logHttpError(response?: any): void {
    const URL = `${environment.baseApiUrls}/logger/http`;

    const dataToSend = {
      code: response?.status?.toString(),
      message: response?.message,
      errors: this.mapErrorResponse(response),
      route: this.router?.url,
      url: response?.url,
      user: this.userService.getUserSync()?.userId,
    } as IErrorLogResponse;

    this.http.post(URL, dataToSend).pipe(take(1)).subscribe();
  }

  private mapErrorResponse(response: any): IErrorDataResponse[] {
    const errors = !!response?.error?.mappedErrorList ? response?.error?.mappedErrorList[0]?.value?.errors : [];
    const errorWasHandledInHybris = !!errors && errors?.length > 0;
    return (errorWasHandledInHybris)
    ? errors.map((error: any) => ({
        code: error?.code,
        errorMessage: error?.message,
        translatedErrorMessage: !!error?.code ? getMessageByCode(error.code, this.translateService) : null,
      } as IErrorDataResponse))
    : [{
        code: is502Error(response) ? '502' : response?.status,
        errorMessage: response?.message,
        translatedErrorMessage: response?.name
      }];
  }
}
